import { Injector, NgModule } from '@angular/core';
import { FormColorDirective } from '../../directives/form-color.directive';
import { BackgroundImageDirective } from '../../directives/background.directive';
import { AuditService } from '@services/audit/audit.service';
import { CustomElementService } from '@services/custom-elements/custom-element.service';
import { TemplateComponent } from '@components/template/template.component';
import { ComponentErrorComponent } from '@components/component-error/component-error.component';
import { CustomCSSService } from '@services/custom-css.service';

@NgModule({
  imports: [FormColorDirective, BackgroundImageDirective, TemplateComponent],
  exports: [FormColorDirective, BackgroundImageDirective],
  providers: [AuditService]
})
export class FormbirdCommonModule {
  constructor(
    private customElementService: CustomElementService, 
    private injector: Injector,
    private customCSSService: CustomCSSService
  ) {
    this.customElementService.convertToCustomElement(TemplateComponent, 'ft-formbird-template', this.injector);
    this.customElementService.convertToCustomElement(ComponentErrorComponent, 'ft-component-error', this.injector);
    this.customElementService.convertToCustomElement(ComponentErrorComponent, 'ft-component-not-found', this.injector);

    // append custom css to head
    this.customCSSService.loadCustomCSS();
  }

  ngDoBootstrap() {}
}
